// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7213c429","453":"853fe8e7","667":"28f0c166","977":"41f08026"}[chunkId] + ".chunk.js";
};